import React from 'react'
import {
  PaddedAssociations,
  PaddedDate
} from 'scripts/helpers/AppHelper'

//  ShowDate will display a padded date component
export const ShowDate = (props) => {
  const {showdate, date} = props
  if (!showdate) { return null }
  return <PaddedDate containerClass='date-time' date={date * 1000} />
}

// ShowAssocWith will display a padded tag badge
export const ShowAssocWith = (props) => {
  const {showassoc, data, customOnClick} = props
  if (!showassoc) { return null }
  return <PaddedAssociations
    type='category'
    data={data}
    containerClass='tags-container hide-on-small'
    assocClass='badges tags'
    truncate={false}
    limit={1}
    customOnClick={customOnClick} />
}



// WEBPACK FOOTER //
// ./assets/js/components/list/helpers/ListHelpers.jsx